import { makeStyles } from '@material-ui/core';

import {
  blue,
  neutral,
  purple,
  red,
  teal,
  yellow,
} from '../../shared/styles/colors';

export const orderDetailCardStyles = makeStyles(theme => ({
  root: {
    color: neutral.D20,
  },
  corridor: {
    fontSize: '17px',
    fontFamily: 'Poppins Bold',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    background: neutral.white,
    padding: '0 1rem',
  },
  defectRateBorder: {
    borderLeft: `3px solid ${red[60]}`,
  },
  defectRate: {
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: red[10],
    display: 'flex',
    borderRight: `1px solid ${neutral.D10}`,
    padding: '0.5rem 1rem',
    marginBottom: '0.5rem',
  },
  defectRateIcon: {
    marginRight: '1rem',
    color: yellow.D11,
  },
  defectRateText: {
    fontSize: '0.875rem',
    color: red[60],
    fontFamily: 'PP Object Sans',
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  defectRateCaption: {
    fontFamily: 'PP Object Sans',
    color: neutral[80],
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  defectCheckedRoot: {
    borderRadius: '2px',
    color: neutral.black,
    padding: 0,
  },
  defectChecked: {
    '&.Mui-checked': {
      color: neutral.black,
    },
  },
  container: {
    width: '100%',
    [theme.breakpoints.up('md')]: {},
    fontSize: '1rem',
    fontFamily: 'PP Object Sans',
  },
  quantity: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: neutral[100],
  },
  detailHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  detailContainer: {
    borderTop: `1px solid ${neutral.D10}`,
  },
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '3rem',
    paddingLeft: '0.5rem',
    width: '100%',
  },
  notes: {
    color: neutral.D15,
    marginBottom: '3px',
  },
  description: {
    padding: '0.5rem 0',
    color: neutral[60],
    fontSize: '0.875rem',
    fontWeight: 400,
    fontFamily: 'PP Object Sans',
  },
  productTitle: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    fontSize: '1rem',
  },
  productPrice: {
    display: 'flex',
  },
  toppings: {
    margin: '0 0 1rem 0.75rem',
  },
  toppingCategory: {
    color: neutral[80],
    fontFamily: 'PP Object Sans',
    fontWeight: 400,
    fontSize: '0.75rem',
  },
  toppingDescription: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontWeight: 500,
    fontSize: '1rem',
  },
  toppingDetail: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  toppingOptions: {
    alignItems: 'center',
    display: 'flex',
    gap: '0.5rem',
  },
  commentWrapper: {
    marginBottom: '20px',
  },
  comments: {
    color: red.D10,
  },
  detailSubtotal: {
    alignItems: 'center',
    gap: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: neutral.white,
    padding: '0',
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      padding: '0',
    },
  },
  subtotalVal: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 700,
  },
  subtotalValLabel: {
    paddingRight: '0.25rem',
    fontWeight: 400,
    color: neutral[60],
  },
  alertMessage: {
    margin: '0 0 0.75rem 0',
  },
  addValue: {
    fontSize: '13px',
    fontFamily: 'Poppins Bold',
    color: teal.D5,
    marginTop: '14px',
    textTransform: 'capitalize',
    padding: '0',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  detailSubtotalKanban: {
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${neutral.D10}`,
    fontSize: '17px',
    [theme.breakpoints.up('md')]: {},
  },
  subtotalValKanban: {
    fontWeight: 600,
  },
  deleteProduct: {
    paddingTop: '0.25rem',
    paddingLeft: '0.5rem',
    borderLeft: `1px solid ${neutral.D11}`,
    cursor: 'pointer',
    marginLeft: '0.5rem',
  },
  deleteProductsDisabled: {
    cursor: 'not-allowed',
  },
  checkProduct: {
    padding: 0,
  },
  checkTopping: {
    padding: 0,
  },
  toppingPrice: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 400,
    color: neutral[60],
  },
  chipDisclaimer: {
    padding: '0.25rem 0.5rem',
  },
  chipText: {
    fontWeight: 500,
    fontFamily: 'PP Object Sans',
  },
  chipDangerIcon: {
    fontSize: '0.75rem',
    color: red[60],
  },
  globalOffer: {
    alignItems: 'center',
    backgroundColor: purple[10],
    display: 'flex',
    borderRight: `1px solid ${neutral.D10}`,
    padding: '0.5rem 1rem',
    marginBottom: '0.5rem',
  },
  globalOfferText: {
    fontSize: '0.875rem',
    color: purple[60],
    fontFamily: 'PP Object Sans',
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  globalOfferCaption: {
    color: neutral[80],
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  globalOfferBorder: {
    borderLeft: `3px solid ${purple[60]}`,
  },
  toppingDisclaimer: {
    alignItems: 'center',
    backgroundColor: blue[10],
    borderLeft: `3px solid ${blue[50]}`,
    display: 'flex',
    padding: '0.5rem 1rem',
    marginBottom: '0.5rem',
    '& > span': {
      color: neutral[80],
      fontSize: '0.75rem',
      fontWeight: 400,
    },
  },
}));
